import { createRef } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

/**Utils */
import { SITE_TITLE, INDEX_URL, PAGES } from "../../helpers/constants";
import { seo } from "../../helpers/seo";
import history from "../../helpers/history";
import { checkString, getCurrentLanguage } from "../../helpers/utils";
import { validateEmail } from "../../helpers/validators";
import { success, error } from "../../helpers/toast";

/**API */
import { api } from "../../api";

/**FirebaseContext */
import { FirebaseContext } from "../../firebase/firebase";

/**Redux */
import { LOADER_VISIBLE, LOADER_INVISIBLE } from "../../redux/actions/loaderActions";

/**Components */
import OnChange from "../../components/OnChange";
import Input from "../../components/Input";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

class MailBox extends OnChange {
    constructor(props) {
        super(props);

        this.state = {
            subject: "",
            userEmail: "",
            message: "",
            userIsAnonymous: false,
        };

        this.sendMessage = this.sendMessage.bind(this);
        this.formValidation = this.formValidation.bind(this);

        this.inputTitleRef = createRef();
        this.inputEmailRef = createRef();
        this.textareaMessageRef = createRef();
    }

    async componentDidMount() {
        seo({
            title: SITE_TITLE + " || Mail Box",
            metaDescription: "",
        });

        const newState = {
            userIsAnonymous: await this.context.api.getIfUserIsAnonymous(),
        };

        this.setState(newState);
    }

    formValidation() {
        const { subject, userEmail = "", message, userIsAnonymous = false } = this.state;
        const { name = "", surname = "", uid, canteen_id } = this.props.user;

        if (!checkString(subject)) {
            this.inputTitleRef?.current?.focus();
            return false;
        }
        if (userIsAnonymous && !validateEmail(userEmail)) {
            this.inputEmailRef?.current?.focus();
            return false;
        }
        if (!checkString(message) || message.length < 10) {
            this.textareaMessageRef?.current?.focus();
            return false;
        }

        const checkCondition = !userIsAnonymous
            ? checkString(name) && checkString(surname) && checkString(uid) && checkString(canteen_id)
            : validateEmail(userEmail) && checkString(uid) && checkString(canteen_id);

        return checkCondition;
    }

    async sendMessage(e) {
        e.preventDefault();

        const { subject, userEmail = "", message, userIsAnonymous } = this.state,
            { canteen_id } = this.props.user;

        try {
            this.props.activateLoader();
            if (this.formValidation()) {
                const token = await this.context?.api.getToken(),
                    language = getCurrentLanguage(),
                    result = await api.chat.newChat(
                        token,
                        canteen_id,
                        subject,
                        message,
                        userIsAnonymous ? userEmail : null,
                        language,
                    );

                if (result) {
                    success(this.props.t("mail_box.send"));

                    const pageToReach = INDEX_URL + (!userIsAnonymous ? PAGES.MESSAGES : PAGES.HOME);

                    history.pushWithCheck(pageToReach);
                } else {
                    error(this.props.t("mail_box.error_send"));
                }
            } else {
                error(this.props.t("mail_box.error_parameters"));
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.props.deactivateLoader();
        }
    }

    renderMailBoxForm() {
        return (
            <>
                <form>
                    {/*Mail*/}
                    <Input
                        innerRef={this.inputTitleRef}
                        type="text"
                        className="form-control"
                        id="mail_box_input_subject"
                        placeholder={this.props.t("mail_box.subject")}
                        value={this.state.subject}
                        onChange={e => this.onChange(e, "subject")}
                    />
                    {
                        //Email of the user
                        this.state.userIsAnonymous && (
                            <Input
                                innerRef={this.inputEmailRef}
                                type="email"
                                className="form-control"
                                id="mail_box_input_email_subject"
                                placeholder={this.props.t("mail_box.email")}
                                value={this.state.userEmail}
                                onChange={e => this.onChange(e, "userEmail")}
                            />
                        )
                    }
                    <div className="form-group">
                        <label htmlFor="mensaje">{this.props.t("mail_box.message")}</label>
                        {/**
								placeholder={this.props.t('mail_box.message')}
							*/}
                        <textarea
                            ref={this.textareaMessageRef}
                            id="mail_box_textarea_message"
                            className="form-control minheight"
                            value={this.state.message}
                            onChange={e => this.onChange(e, "message")}
                        />
                    </div>
                    <div className="form-group">
                        <div className="btns-area">
                            <button type="submit" className="btn btn-primary" onClick={this.sendMessage}>
                                {this.props.t("mail_box.send_message")}
                            </button>
                        </div>
                    </div>
                </form>
            </>
        );
    }

    render() {
        return (
            <>
                <Header />
                <section className="middle-content">
                    <div className="container form-area maxwidth">
                        <div className="head-area">
                            <div className="row align-items-center justify-content-center">
                                <div className="col-12 col-sm-12 col-md-12">
                                    <div className="default-heading text-uppercase">
                                        {" "}
                                        <h2>
                                            {" "}
                                            <strong>{this.props.t("mail_box.title")}</strong>{" "}
                                        </h2>{" "}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-center">
                            <div className="col-12 col-sm-12">{this.renderMailBoxForm()}</div>
                        </div>
                    </div>
                </section>
                <Footer />
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    // ... computed data from state and optionally ownProps
    return {
        ...state,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        activateLoader: () => dispatch({ type: LOADER_VISIBLE }),
        deactivateLoader: () => dispatch({ type: LOADER_INVISIBLE }),
    };
};

MailBox.contextType = FirebaseContext;

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MailBox));
